import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { TextAreaInput1, TextInput } from '../../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { ButtonFilledAutoWidth } from '../../../components/button'
import { CreateTemplateService, UpdateTemplateService } from '../../../services/TemplateServices'
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { AiOutlineDelete, AiOutlinePlus } from 'react-icons/ai'

function TemplateCE() {
 
  const [data,setdata] = useState({label:'',variables:[],name:'',body_wati:'',body_telinfy:'',wati_enabled:false,telinfy_enabled:false});  
  const [error,seterror] = useState({label:'',variables:'',name:'',body_wati:'',body_telinfy:'',wati_enabled:'',telinfy_enabled:''}); 
  
  const {state} = useLocation();
  const navigate = useNavigate();

  // const {id,department_name} = state;


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      setdata({...data,...state})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
  
      if(state?._id === undefined || state?._id === null){
        const response = await CreateTemplateService(data)
        if (response.status === 201) {
          resetform()
          toast.success('Template Created Successfully')
        }   
      }else{
        let send_data = {...data}
        send_data["id"] = state?._id
        const response = await UpdateTemplateService(send_data,state?._id)
        if (response.status === 200) {
          resetform()
          navigate(-1)
          toast.success('Template Updated Successfully')
        }   
  }
  }

  function resetform(){
    setdata({label:'',variables:[],name:'',body_wati:'',body_telinfy:'',wati_enabled:false,telinfy_enabled:false})
    seterror({label:'',variables:'',name:'',body_wati:'',body_telinfy:'',wati_enabled:'',telinfy_enabled:''})
  }

  

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      

        <h6 className='font-bold'>{(state?.id !== null && state?.id !== undefined) ? 'Edit' : 'Add'} Template Message</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Template Message</b> for your reference.</h6>
     
       <TextInput 
            label={'Label'}  
            variant="standard"
            name="label"
            type="text"
            error={error.label}
            value={data.label}
            handlechange={handlechange}
            placeholder="Enter your Label"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

        <TextInput 
            label={'Name'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your Designation name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>
    

      
         <TextAreaInput1 
            label={'Wati Body'}  
            variant="standard"
            name="body_wati"
            type="text"
            error={error.body_wati}
            value={data.body_wati}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

          <TextAreaInput1 
            label={'Body Telinfy'}  
            variant="standard"
            name="body_telinfy"
            type="text"
            error={error.body_telinfy}
            value={data.body_telinfy}
            handlechange={handlechange}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>     

            <div className='mb-2'>
              <div className='flex items-center justify-between mt-2 mb-1'>
              <h6 className='text-[11.5px] font-[600]'>Add Variables</h6>
              <AiOutlinePlus
                className='bg-slate-200 p-[4px] rounded cursor-pointer'
                onClick={() => setdata({
                  ...data,
                  variables: [
                    ...data.variables,
                    { label: '', key: '' }
                  ]
                })}
              />
              </div>
              {data.variables.length > 0 &&
              <>
              <div className='text-[11px] flex items-center font-[800]'>
                <h6 className='min-w-[46%] w-[46%] max-w-[46%]'>Label</h6>
                <h6 className='min-w-[46%] w-[46%] max-w-[46%]'>Key</h6>
              </div>
              {data.variables.map((v, i) => (
                <div key={i} className='flex items-center mt-1 gap-2'>
                  <input
                    className='border border-slate-300 focus:outline-none px-2 py-1 text-[12px] rounded w-28'
                    placeholder='Display Label'
                    value={v.label}
                    onChange={e => {
                      const newVars = [...data.variables]
                      newVars[i].label = e.target.value
                      setdata({ ...data, variables: newVars })
                    }}
                  />
                  <input
                    className='border border-slate-300 focus:outline-none px-2 py-1 text-[12px] rounded w-28'
                    placeholder='Key'
                    value={v.key}
                    onChange={e => {
                      const newVars = [...data.variables]
                      newVars[i].key = e.target.value
                      setdata({ ...data, variables: newVars })
                    }}
                  />
                  {/* <button
                    className='ml-1 text-blue-600 text-xs underline'
                    onClick={() => {
                      // No-op for edit, fields are always editable
                    }}
                    style={{ display: 'none' }}
                  >Edit</button> */}
                  <button
                    className='ml-1 text-red-600 text-xs underline'
                    onClick={() => {
                      const newVars = data.variables.filter((_, idx) => idx !== i)
                      setdata({ ...data, variables: newVars })
                    }}
                  ><AiOutlineDelete /></button>
                </div>
              ))}
              </>}
            </div>


            <div className='flex items-center mt-0 mr-2'>
            {data?.wati_enabled ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,wati_enabled:!data.wati_enabled})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,wati_enabled:!data.wati_enabled})}  /> }
            <h6 className="text-[10px] font-[600] ml-1">WATI Enabled</h6> 
            </div>  


            <div className='flex items-center mt-0 mr-2'>
            {data?.telinfy_enabled ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,telinfy_enabled:!data.telinfy_enabled})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,telinfy_enabled:!data.telinfy_enabled})}  /> }
            <h6 className="text-[10px] font-[600] ml-1">Telinfy Enabled</h6> 
            </div>  

<div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE TEMPLATE" : "ADD TEMPLATE"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default TemplateCE